export * from '@primeuix/themes/aura/floatlabel';
export { default } from '@primeuix/themes/aura/floatlabel';
